import { RootState } from "../types";

export const userSelector = (state: RootState) => state.user.user;
export const userPlanSelector = (state: RootState) => state.user.user.planId;
export const userAppointmentsSelector = (state: RootState) =>
  state.user.user.appointments;
export const cancelAppointmentReasonsSelector = (state: RootState) =>
  state.user.cancelAppointmentReasons;
export const userTherapistsSelector = (state: RootState) =>
  state.user.user.therapists;
export const userAllAppointmentProgramsSelector = (state: RootState) =>
  state.user.user.allAppointmentPrograms;
export const allflowUserSelector = (state: RootState) =>
  state.utils.allUserFlows;
export const currentUserFlowIdSelector = (state: RootState) =>
  state.user.currentUserFlowId;
export const existingUserFlowIdSelector = (state: RootState) =>
  state.utils.existingUserFlowId;
export const guestUserFlowIdSelector = (state: RootState) =>
  state.utils.guestUserFlowId;
export const nextStepSelector = (state: RootState) => state.user.nextStep;
export const questionnaireIdSelector = (state: RootState) =>
  state.user.currentQuestionnaireId;
export const currentQuestionnaireSelector = (state: RootState) =>
  state.user.currentQuestionnaire;
export const currentQuestionnaireCompanyIdSelector = (state: RootState) =>
  state.user.currentQuestionnaireCompanies?.Id;
export const nextQuestionIdSelector = (state: RootState) =>
  state.user.nextQuestionId;
export const isEndSelector = (state: RootState) => state.user.isEnd;
export const currentQuestionSelector = (state: RootState) =>
  state.user.currentQuestion;
export const currentQuestionIdSelector = (state: RootState) =>
  state.user.currentQuestionId;
export const questionsOptionsSelector = (state: RootState) =>
  state.user.questionsOptions;
export const prevencherChatMessagesSelector = (state: RootState) =>
  state.user.prevencherChatMessages;
export const prevencherPOCMessagesSelector = (state: RootState) =>
  state.user.prevencherPOCMessages;
export const endQuestionSelector = (state: RootState) => state.user.endQuestion;
export const startQuestionSelector = (state: RootState) =>
  state.user.startQuestion;
export const exercisesSelector = (state: RootState) =>
  state.user.user.exercises;
export const allQuestionsSelector = (state: RootState) =>
  state.user.allQuestions;
export const allAnswersSelector = (state: RootState) => state.user.allAnswers;
export const allAudioAnswersSelector = (state: RootState) =>
  state.user.allAudioAnswers;
export const userProtocolIdSelector = (state: RootState) => state.user.user.protocolId;
export const userProtocolComponentsSelector = (state: RootState) => state.user.userProtocolComponents;
export const questionnaireCapabilitiesSelector = (state: RootState) =>
  state.user.questionnaireCapabilities;
export const activeContactSelector = (state: RootState) => state.user.activeContact;
export const activeContactTokenSelector = (state: RootState) => state.user.activeContactToken;
export const isContactSessionSelector = (state: RootState) => 
  !!state.user.activeContact && !!state.user.activeContactToken;
export const linkedClientsSelector = (state: RootState) => state.user.linkedClients;
export const MultyCompaniesListSelector = (state: RootState) =>
  state.user.user.usersMultipleCompanies;
